module.exports = __webpack_public_path__ + "static/img/2.dd85996.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/2.jpg
// module id = f1M5
// module chunks = 1